'use strict';
import Splide from '@splidejs/splide';
window.addEventListener('DOMContentLoaded', () => {
  initCaseStudySplide();
  initworkSingleSplide();
});
const initworkSingleSplide = () => {
  const workSingleSplideOptions = {
    mediaQuery: 'min',
    type: 'loop',
    rewind: true,
    perMove: 1,
    perPage: 1,
    autoplay: false,
    drag: true,
    speed: 1000,
    clones: 0,
    snap: true,
    completely: false,
    pagination: true,
    // breakpoints: {
    //   960: {
    //     destroy: true,
    //   },
    // },
  };
  const workSingleSplide = new Splide(
    '.works-single-slide',
    workSingleSplideOptions
  );
  workSingleSplide.mount();
};
const initCaseStudySplide = () => {
  const caseStudySplideOptions = {
    mediaQuery: 'min',
    type: 'loop',
    rewind: true,
    perMove: 1,
    perPage: 2.1,
    autoplay: false,
    drag: true,
    gap: '2em',
    speed: 1000,
    clones: 2,
    snap: true,
    arrowPath:
      'm20 40-3.441-3.5 14.1-14.069H0v-4.857h30.662l-14.1-14.1L20.003.006l20 20z',
    breakpoints: {
      750: {
        perPage: 3,
        gap: '4.4em',
        // destroy: true,
      },
    },
  };

  const caseStudySplide = new Splide(
    '.case-study__list',
    caseStudySplideOptions
  );
  caseStudySplide.mount();
};
